// Text should only contain letters, numbers and certain special characters
export function validateText(text: string): string {
  if (!text) return text
  return text.replace(/[^0-9a-zA-Z \.\,\_\'\-]/g, '')
}

export function isTextValid(text: string): boolean {
  if (!text) return false
  return (/^[0-9a-zA-Z ]+$/).test(text)
}